import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import DeviceDefectService from "src/service/deviceDefect";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update Defect Type",
  },
];

const validationSchema = yup.object({
  defect_type_name: yup
    .string("Defect Type Name")
    .min(1, "Defect Type Name should be of minimum 1 characters in length")
    .max(30, "Defect Type Name should be of maximum 30 characters in length")
    .required("Defect Type Name is required"),
});

const UpdateDeviceDefect = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    defect_type_name: "",
    c_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchdefectTypedata = async () => {
      try {
        const res = await DeviceDefectService.getDefectList({
          id: param.id,
        });

        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          defect_type_name: res.data[0].defect_type_name,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchdefectTypedata();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await DeviceDefectService.UpdateDefectType(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/devicedefect");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title="Update Defect Type" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Defect Type
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/devicedefect");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="defect_type_name">
                Defect Type Name
              </CustomFormLabel>
              <CustomTextField
                id="defect_type_name"
                name="defect_type_name"
                type="text"
                value={values.defect_type_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.defect_type_name && Boolean(errors.defect_type_name)
                }
                helperText={touched.defect_type_name && errors.defect_type_name}
                variant="outlined"
                placeholder="Enter Defect Type"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Update
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateDeviceDefect;
